const instagram = 'https://www.instagram.com/chocolateselceibo.bo';

export default instagram;
